import moment from "moment";

/**
 * Competition start/end datetimes are wall-clock values in the DB (what admin picks).
 * Sequelize JSON often appends "Z", which makes moment() shift by the browser timezone.
 * Always interpret and format in UTC so 12:30 in DB displays as 12:30 everywhere.
 */
export function competitionMoment(value) {
  if (value == null || value === "") return moment.invalid();
  const s = String(value).trim();
  if (!s) return moment.invalid();

  if (/[zZ]$/.test(s) || /[+-]\d{2}:\d{2}$/.test(s)) {
    return moment.utc(s);
  }

  const normalized = s.includes("T") ? s : s.replace(" ", "T");
  return moment.utc(normalized);
}

export function formatCompetitionDateTime(value, format = "DD MMM YYYY, HH:mm") {
  const m = competitionMoment(value);
  return m.isValid() ? m.format(format) : "";
}

/** Value for `<input type="datetime-local" />` */
export function toCompetitionDateTimeInputValue(value) {
  const m = competitionMoment(value);
  return m.isValid() ? m.format("YYYY-MM-DDTHH:mm") : "";
}
